var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-rtc",class:{
 'mine':_vm.data.mine,
 'call-over': !_vm.data.mine && _vm.data.content.uint32_video_status_type === 2,
 'isMobile': _vm.isMobile
 },attrs:{"title":_vm.formatTime},on:{"contextmenu":function($event){$event.preventDefault();return _vm.onContextMenu.apply(null, arguments)}}},[(!_vm.data.mine)?_c('span',{staticClass:"icon",class:{'audio': _vm.data.content.uint32_call_type === 2}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.processedText))]),(_vm.data.mine)?_c('span',{staticClass:"icon icon-right",class:{'audio': _vm.data.content.uint32_call_type === 2}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }